"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const use_translation_wrapper_1 = require("../../../common/hooks/use-translation-wrapper");
const common_1 = require("../../../common");
const api_1 = require("../../../common/api");
const formik_1 = require("formik");
const OpenshiftVersionHelperText_1 = require("./OpenshiftVersionHelperText");
const OpenShiftVersionsContext_1 = require("../clusterWizard/OpenShiftVersionsContext");
const OcmOpenShiftVersionSelect = ({ versions }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    const { values: { customOpenshiftSelect }, } = (0, formik_1.useFormikContext)();
    const selectOptions = react_1.default.useMemo(() => versions.map((version) => ({
        label: version.supportLevel === 'beta'
            ? version.label + ' - ' + t('ai:Developer preview release')
            : version.label,
        // This is the "key" from openshift-versions API response
        // It can either be in the long or short (for default versions) form
        value: version.value,
    })), [versions, t]);
    const [isOpenshiftVersionModalOpen, setIsOpenshiftVersionModalOpen] = react_1.default.useState(false);
    const showOpenshiftVersionModal = () => {
        setIsOpenshiftVersionModalOpen(true);
    };
    const updatedSelectOptions = react_1.default.useMemo(() => {
        if (customOpenshiftSelect &&
            !selectOptions.find((option) => option.value === customOpenshiftSelect.value)) {
            return [
                {
                    label: customOpenshiftSelect.label,
                    value: customOpenshiftSelect.value,
                },
            ];
        }
        return [];
    }, [selectOptions, customOpenshiftSelect]);
    const { allVersions } = (0, OpenShiftVersionsContext_1.useOpenShiftVersionsContext)();
    const getHelperText = (value, inModal) => {
        return (0, OpenshiftVersionHelperText_1.getOpenshiftVersionHelperText)(allVersions, value, t, inModal);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.OpenShiftVersionDropdown, { name: "openshiftVersion", items: selectOptions, versions: versions, getHelperText: getHelperText, showReleasesLink: api_1.isInOcm, showOpenshiftVersionModal: showOpenshiftVersionModal, customItems: updatedSelectOptions }),
        isOpenshiftVersionModalOpen && (react_1.default.createElement(common_1.OpenShiftVersionModal, { allVersions: allVersions, setOpenshiftVersionModalOpen: setIsOpenshiftVersionModalOpen, getHelperText: getHelperText }))));
};
exports.default = OcmOpenShiftVersionSelect;
//# sourceMappingURL=OcmOpenShiftVersionSelect.js.map